import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
import { Menu, X } from 'lucide-react';
export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`} data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className={`bg-white border-3 border-text rounded-2xl flex items-center justify-between px-6 py-3 transition-all duration-300 ${isScrolled ? 'neo-shadow-sm' : 'neo-shadow'}`} data-id="element-104">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-105">
            <motion.span className="text-3xl" whileHover={{
            rotate: 20,
            scale: 1.2
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 10
          }} data-id="element-106">
              🐾
            </motion.span>
            <span className="font-display font-black text-xl md:text-2xl tracking-tight" data-id="element-107">
              Patitas Felices
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-108">
            <ul className="flex items-center gap-6 font-bold" data-id="element-109">
              {navLinks.map(link => <li key={link.name} data-id="element-110">
                  <a href={link.href} className="hover:text-primary transition-colors relative group" data-id="element-111">
                    {link.name}
                    <span className="absolute -bottom-1 left-0 w-0 h-1 bg-primary transition-all group-hover:w-full rounded-full" data-id="element-112"></span>
                  </a>
                </li>)}
            </ul>
            <WhatsAppButton variant="primary" className="py-2 px-4 text-base" data-id="element-113">
              Reservar Turno
            </WhatsAppButton>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 bg-bg border-2 border-text rounded-lg neo-shadow-sm" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-114">
            {isMobileMenuOpen ? <X size={24} data-id="element-115" /> : <Menu size={24} data-id="element-116" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="md:hidden mt-4 bg-white border-3 border-text rounded-2xl neo-shadow p-6 flex flex-col gap-4 absolute left-4 right-4" data-id="element-117">
            <ul className="flex flex-col gap-4 font-bold text-lg text-center" data-id="element-118">
              {navLinks.map(link => <li key={link.name} data-id="element-119">
                  <a href={link.href} className="block py-2 hover:bg-bg rounded-lg border-2 border-transparent hover:border-text transition-all" onClick={() => setIsMobileMenuOpen(false)} data-id="element-120">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <div className="flex justify-center mt-4" data-id="element-121">
              <WhatsAppButton variant="primary" className="w-full" data-id="element-122">
                Reservar Turno
              </WhatsAppButton>
            </div>
          </motion.div>}
      </div>
    </header>;
};